import { Button, Row } from '@components'
import theme from '@utils/theme'
import { useState } from 'react'
import { Fragment } from 'react/jsx-runtime'

interface IFilter {
  title: string
  key: string
  bg: keyof typeof theme.colors
  tc: keyof typeof theme.colors
}

interface IBookManagementFilter {
  onChangeFilter: (filter: IFilter) => void
}

const BookManagementFilter = ({ onChangeFilter }: IBookManagementFilter) => {
  const [activeFilter, setActiveFilter] = useState<IFilter>({
    title: 'All',
    key: 'All',
    bg: 'primary50',
    tc: 'primary',
  })

  const filters: IFilter[] = [
    { title: 'All', key: 'All', bg: 'primary50', tc: 'primary' },
    { title: 'Self', key: 'Self', bg: 'primary50', tc: 'primary' },
    { title: 'Others', key: 'Others', bg: 'primary50', tc: 'primary' },
  ]

  const onClick = (filter: IFilter) => {
    setActiveFilter(filter)
    onChangeFilter(filter)
  }

  return (
    <Fragment>
      <Row colGap={20}>
        {filters.map((filter) => (
          <Button
            title={filter.title}
            key={filter.key}
            bg={filter?.bg}
            tc={filter?.tc}
            border={
              activeFilter?.key === filter.key ? activeFilter.tc : 'grey100'
            }
            onClick={() => onClick(filter)}
          />
        ))}
      </Row>
    </Fragment>
  )
}

export default BookManagementFilter
